import React from 'react'
import { useTranslation } from 'react-i18next'
import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import image1422835925562757125 from 'assets/landing-images/twitter/twitter-1422835925562757125.jpg'
import image1442879700049612800 from 'assets/landing-images/twitter/twitter-1442879700049612800.jpg'
import image1446403018182873088 from 'assets/landing-images/twitter/twitter-1446403018182873088.jpg'
import image1446411363333595136 from 'assets/landing-images/twitter/twitter-1446411363333595136.jpg'
import image1456037401562779657 from 'assets/landing-images/twitter/twitter-1456037401562779657.jpg'
import image1460983933454143494 from 'assets/landing-images/twitter/twitter-1460983933454143494.jpg'
import image1476523798946107397 from 'assets/landing-images/twitter/twitter-1476523798946107397.jpg'

import { Button } from '../'
import * as S from './styleds'

const tweets = [
  { url: 'https://twitter.com/el33th4xor/status/1446403018182873088', image: image1446403018182873088 },
  { url: 'https://twitter.com/BNBCHAIN/status/1422835925562757125', image: image1422835925562757125 },
  { url: 'https://twitter.com/Rewkang/status/1456037401562779657', image: image1456037401562779657 },
  { url: 'https://twitter.com/Fiskantes/status/1476523798946107397', image: image1476523798946107397 },
  { url: 'https://twitter.com/pangolindex/status/1442879700049612800', image: image1442879700049612800 },
  { url: 'https://twitter.com/ShamanShiitake/status/1446411363333595136', image: image1446411363333595136 },
  { url: 'https://twitter.com/Natalia_Ameline/status/1460983933454143494', image: image1460983933454143494 }
]

export const TweetsSlider = () => {
  const { t } = useTranslation()
  return (
    <S.TrustedSlider>
      <Slider
        dots
        arrows={false}
        autoplay
        autoplaySpeed={5000}
        pauseOnHover
        pauseOnFocus
        pauseOnDotsHover
        infinite
        slidesToShow={3}
        slidesToScroll={3}
        responsive={[
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]}
      >
        {tweets.map(({ url, image }) => {
          return (
            <S.TrustedCard key={url}>
              <S.TrustedCardImage src={image} alt={t('Positive Feedback of WOWswap')} />
              <Button
                className="trusted-card-button"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                variant="secondary"
                color="blue"
              >
                {t('Read on Twitter')}
              </Button>
            </S.TrustedCard>
          )
        })}
      </Slider>
    </S.TrustedSlider>
  )
}
